import React from 'react';

const SvgSe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SE_svg__b" fill="#fff">
        <use xlinkHref="#SE_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#SE_svg__a" />
      <path fill="#157CBB" mask="url(#SE_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#FFD34D"
        mask="url(#SE_svg__b)"
        d="M0 12h8v8h4v-8h16V8H12V0H8v8H0z"
      />
    </g>
  </svg>
);

export default SvgSe;
